import styled from 'styled-components'

import { colors, spaces } from '@/config/global-parameters'

const HeaderWarn = styled.div`
  background-color: ${colors.colorYellow};
  padding: ${spaces.xxs} ${spaces.xs};
  border-radius: ${spaces.xxs};
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    font-size: 9px;
  }
`

export default HeaderWarn
